import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

export const bankSlipStatus = defineEnum({
  registradocip: { label: msg`Registrado` },
  baixado: { label: msg`Baixado` },
  settlement: { label: msg`Liquidado` },
  nosettlement: { label: msg`Não liquidado` },
  naoprotestado: { label: msg`Não protestado` },
  sustado: { label: msg`Sustado` },
  devolvido: { label: msg`Devolvido` },
  cancelado: { label: msg`Cancelado` },
  erroapresentartitulo: { label: msg`Erro ao apresentar título` },
  retirado: { label: msg`Retirado` },
});
